import { Empty } from 'antd';

import IntlMessages from '@src/util/IntlMessages';

import styles from './styles.module.less';

interface WorkJourneyManagementEmptyStateProps {
  /** Message shown when the tab simply has no data. */
  messageId: string;
  /** Distinguishes "nothing to show" from "filters hid everything". */
  filtered?: boolean;
}

export const WorkJourneyManagementEmptyState = ({
  messageId,
  filtered = false,
}: WorkJourneyManagementEmptyStateProps) => (
  <Empty
    className={styles.empty}
    image={Empty.PRESENTED_IMAGE_SIMPLE}
    description={
      <IntlMessages id={filtered ? 'workJourney.management.empty.filtered' : messageId} />
    }
  />
);
